// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__25nh_","errors":"Errors_errors__yNO6R"};